import styled from 'styled-components'
import React from 'react'
import media from './theme-media.js'
import theme from './theme.js'
import { Link as GatsbyLink } from 'gatsby'

export const UnstyledJumboheading = props => {
  const to = props.to
  let text = props.children

  if (props.to) text = <Link to={to}>{text}</Link>

  return <h2 {...props}>{text}</h2>
}

const JumboHeading = styled(UnstyledJumboheading)`
  color: ${theme.color.grey[9]};
  font-size: 8.5rem;
  font-family: nitti, monospace;
  font-weight: 600;
  line-height: 1em;
  margin-bottom: ${theme.pad.mediumSmall};
  margin-top: -.2em;
  color: ${theme.color.grey.darkest};
  letter-spacing: -.05em;
  word-spacing: -.15em;

  ${media.phone`font-size: 4rem;`}
`

const Link = styled(GatsbyLink)`
  &:hover {
    text-decoration: underline;
  }
`

export default JumboHeading 